<template>
    <div class="drag"
         ref="dragDiv">
        <div class="drag_bg"></div>
        <div class="drag_text">{{confirmWords}}</div>
        <div ref="moveDiv"
             id="handler"
             @mousedown="mousedownFn($event)"
             :class="{'handler_ok_bg':confirmSuccess}"
             class="handler handler_bg"
             style="position: absolute;top: 0px;left: 0px;">
            <i class="el-icon-d-arrow-right"></i>
        </div>
        <transition name="el-zoom-in-top">
            <span v-if="isSliderShow"
                  class="slider-valid">请先滑动验证！</span>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        isSliderShow: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            beginClientX: 0, // 距离屏幕左端距离
            mouseMoveStata: false, /* 触发拖动状态  判断 */
            // maxwidth: '', /* 拖动最大宽度，依据滑块宽度算出来的 */
            confirmWords: '请按住滑块，拖动到最右边', /* 滑块文字 */
            confirmSuccess: false /* 验证成功判断 */
        }
    },
    computed: {
        maxwidth () { /* 拖动最大宽度，依据滑块宽度算出来的 */
            return this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth - 2
        }
    },
    methods: {
        mousedownFn: function (e) {
            if (!this.confirmSuccess) {
                e.preventDefault && e.preventDefault() // 阻止文字选中等 浏览器默认事件
                this.mouseMoveStata = true
                this.beginClientX = e.clientX
            }
        }, // mousedoen 事件
        successFunction () {
            if (this.mouseMoveStata) {
                this.confirmSuccess = true
                this.confirmWords = '验证通过'
                if (window.addEventListener) {
                    document.getElementsByTagName('html')[0].removeEventListener('mousemove', this.mouseMoveFn)
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup', this.moseUpFn)
                } else {
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup', () => { })
                }
                document.getElementsByClassName('drag_text')[0].style.color = '#fff'
                document.getElementsByClassName('drag_text')[0].style.paddingLeft = 0
                document.getElementsByClassName('drag_text')[0].style.paddingRight = 40 + 'px'
                document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 1 + 'px'
                document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 1 + 'px'
                document.getElementsByClassName('handler')[0].style.borderRight = 'none'
                setTimeout(() => {
                    this.$emit('success')
                }, 500)
            } else {
                if (window.addEventListener) {
                    document.getElementsByTagName('html')[0].removeEventListener('mousemove', this.mouseMoveFn)
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup', this.moseUpFn)
                } else {
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup', () => { })
                }
            }
        }, // 验证成功函数
        mouseMoveFn (e) {
            if (this.mouseMoveStata) {
                let width = e.clientX - this.beginClientX
                if (width > 0 && width <= this.maxwidth) {
                    document.getElementsByClassName('handler')[0].style.left = width + 'px'
                    document.getElementsByClassName('handler')[0].style.borderLeft = '1px solid #dcdcdc'
                    document.getElementsByClassName('drag_bg')[0].style.width = width + 'px'
                    document.getElementsByClassName('drag_text')[0].style.color = 'transparent'
                } else if (width > this.maxwidth) {
                    this.successFunction()
                }
            }
        }, // mousemove事件
        moseUpFn (e) {
            if (this.mouseMoveStata) {
                this.mouseMoveStata = false
                var width = e.clientX - this.beginClientX
                if (width < this.maxwidth) {
                    document.getElementsByClassName('handler')[0].style.left = 0 + 'px'
                    document.getElementsByClassName('handler')[0].style.borderLeft = 'none'
                    document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px'
                    document.getElementsByClassName('drag_text')[0].style.paddingLeft = 50 + 'px'
                    document.getElementsByClassName('drag_text')[0].style.color = '#666'
                }
            }
        } // mouseup事件
    },
    mounted () {
        this.$nextTick(() => {
            document.getElementsByTagName('html')[0].addEventListener('mousemove', this.mouseMoveFn)
            document.getElementsByTagName('html')[0].addEventListener('mouseup', this.moseUpFn)
        })
    }
}
</script>

<style scoped>
.el-zoom-in-top-enter-active,
.el-zoom-in-top-leave-active {
    opacity: 1;
    transform: scaleY(1);
    transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
        opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
    transform-origin: center top;
}
.el-zoom-in-top-enter,
.el-zoom-in-top-leave-active {
    opacity: 0;
    transform: scaleY(0);
}

.el-zoom-in-bottom-enter-active,
.el-zoom-in-bottom-leave-active {
    opacity: 1;
    transform: scaleY(1);
    transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
        opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
    transform-origin: center bottom;
}
.el-icon-d-arrow-right {
    font-size: 18px;
    color: #999;
}
.slider-valid {
    position: absolute;
    left: 0;
    color: #f36a6a;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    top: 45px;
}
.drag {
    position: relative;
    background-color: #f6f6f6;
    width: 100%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 1px solid #dcdcdc;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.handler {
    width: 50px;
    height: 43px;
    border-right: 1px solid #dcdcdc;
    cursor: move;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}
.handler_bg {
    background-color: #fff;
}
.handler_ok_bg {
    background-color: #fff;
}
.drag_bg {
    background-color: #3ac9a8;
    height: 43px;
    width: 0px;
}
.drag_text {
    position: absolute;
    top: 0px;
    width: 100%;
    text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
    font-size: 14px;
    color: #666;
    padding-left: 50px;
    box-sizing: border-box;
}
</style>
